import {API} from "@/utils/api";
import axios from 'axios';

export const namespaced = true;

export const state = () => ({
    accept: localStorage.getItem('accept') || false,
});

export const getters = {
    hasAccepted: state => state.accept && state.accept == 1,
    getAccepted: state => state.accept,
}

export const mutations = {
    set_accept(state, accept, user) {
        state.accept = accept
    }
};

export const actions = {
    setAccept({commit}, accept) {
        return new Promise((resolve, reject) => {
            commit('set_accept', accept);
            localStorage.setItem('accept', accept);
            resolve()
        })
    }
};

